var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"g-paiban-task-fly"},[_c('div',{ref:"cardRef",staticClass:"g-paiban-task-fly__card",style:(_vm.cardStyle)},[_c('i',{staticClass:"iconfont icon-jiarurenwuliebiao",staticStyle:{"color":"#18a8c7","font-size":"60px","font-weight":"bold"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }